<script lang="ts" setup>
interface Props {
  loading?: boolean; 
  clearable?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  onClear?: () => void;
  loaderType?: 'spinner' | 'line';
}

const props = withDefaults(defineProps<Props>(), {
  loaderType: 'spinner', 
  loading: false,
  onClear: () => {},
  fullWidth: false
});

</script>

<template>
  <IonItem
    :disabled="disabled"
    lines="none"
    class="input-wrapper"
  >
    <!-- Input Content -->
    <div class="input-content">
      <slot />
    </div>

    <!-- Spinner Loader -->
    <IonSpinner
      v-if="loading && loaderType === 'spinner'"
      slot="end"
      name="crescent"
      color="medium"
      :duration="900"
    />

    <!-- Clear Button -->
    <IonButton
      v-if="!loading && !fullWidth"
      slot="end"
      fill="clear"
      color="medium"
      :style="{ visibility: clearable ? 'visible' : 'hidden' }"
      :disabled="disabled"
      @click="onClear"
    >
      <IonIcon
        slot="icon-only"
        class="fa-fw fa-light fa-xmark"
      />
    </IonButton>

    <!-- Line Loader -->
    <div
      v-if="loading && loaderType === 'line'"
      class="line-loader"
    />
  </IonItem>
</template>

<style scoped>
.input-wrapper {
  position: relative;
}

.input-content {
  flex: 1;
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--ion-color-step-200);
}

/* disable border bottom if input element has error or helper text as this also adds border */
.input-wrapper:has(.input-bottom) .input-content {
  border-bottom: none;
}

.line-loader {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: var(--ion-color-primary);
  animation: loading-animation 1.5s infinite linear;
}

@keyframes loading-animation {
  0% {
    transform: scaleX(0);
    transform-origin: left;
  }
  50% {
    transform: scaleX(0.5);
    transform-origin: left;
  }
  100% {
    transform: scaleX(0);
    transform-origin: right;
  }
}
</style>